import { useTranslation } from 'react-i18next';

import cn from 'classnames';

const styles = {
  container: 'max-w-[1080px] mx-auto px-4 sm:px-6 lg:px-8 py-6',
  title: 'text-3xl font-bold text-gray-900 mb-10',
  sectionTitle: 'text-lg font-bold text-gray-800 mt-8 mb-2',
  paragraph: 'text-base text-gray-700 mb-4',
  bold: 'font-bold',
  list: 'pl-5 text-base text-gray-700 mb-4',
  listItem: 'list-disc',
  link: 'underline'
};

export const PrivacyPolicyPage = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'privacyPolicyPage' });

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t('title')}</h1>
      <p className={cn(styles.paragraph, styles.bold)}>{t('lastUpdated')}</p>
      <p className={styles.paragraph}>{t('introduction')}</p>

      <h2 className={styles.sectionTitle}>{t('whatWeDoTitle')}</h2>
      <p className={styles.paragraph}>{t('whatWeDoContent')}</p>

      <h2 className={styles.sectionTitle}>{t('typesOfPersonalInfoTitle')}</h2>
      <p className={styles.paragraph}>{t('typesOfPersonalInfoContent1')}</p>
      <ul className={styles.list}>
        <li className={styles.listItem}>{t('typesOfPersonalInfoList.item1')}</li>
        <li className={styles.listItem}>{t('typesOfPersonalInfoList.item2')}</li>
        <li className={styles.listItem}>{t('typesOfPersonalInfoList.item3')}</li>
        <li className={styles.listItem}>{t('typesOfPersonalInfoList.item4')}</li>
        <li className={styles.listItem}>{t('typesOfPersonalInfoList.item5')}</li>
        <li className={styles.listItem}>{t('typesOfPersonalInfoList.item6')}</li>
        <li className={styles.listItem}>{t('typesOfPersonalInfoList.item7')}</li>
        <li className={styles.listItem}>{t('typesOfPersonalInfoList.item8')}</li>
        <li className={styles.listItem}>{t('typesOfPersonalInfoList.item9')}</li>
        <li className={styles.listItem}>{t('typesOfPersonalInfoList.item10')}</li>
      </ul>
      <p className={styles.paragraph}>{t('typesOfPersonalInfoContent2')}</p>

      <h2 className={styles.sectionTitle}>{t('sourcesTitle')}</h2>
      <p className={styles.paragraph}>{t('sourcesContent')}</p>

      <h2 className={styles.sectionTitle}>{t('usingInfoTitle')}</h2>
      <p className={styles.paragraph}>{t('usingInfoContent1')}</p>
      <p className={styles.paragraph}>{t('usingInfoList.title')}</p>
      <ul className={styles.list}>
        <li className={styles.listItem}>{t('usingInfoList.item1')}</li>
        <li className={styles.listItem}>{t('usingInfoList.item2')}</li>
        <li className={styles.listItem}>{t('usingInfoList.item3')}</li>
        <li className={styles.listItem}>{t('usingInfoList.item4')}</li>
        <li className={styles.listItem}>{t('usingInfoList.item5')}</li>
      </ul>
      <p className={styles.paragraph}>{t('usingInfoContent2')}</p>
      <p className={styles.paragraph}>{t('usingInfoContent3')}</p>

      <h2 className={styles.sectionTitle}>{t('sharingTitle')}</h2>
      <p className={styles.paragraph}>{t('sharingContent1')}</p>
      <p className={styles.paragraph}>{t('sharingContent2')}</p>
      <p className={styles.paragraph}>{t('sharingContent3')}</p>
      <p className={styles.paragraph}>{t('sharingContent4')}</p>
      <p className={styles.paragraph}>{t('sharingContent5')}</p>

      <h2 className={styles.sectionTitle}>{t('transferringTitle')}</h2>
      <p className={styles.paragraph}>{t('transferringContent')}</p>

      <h2 className={styles.sectionTitle}>{t('securingTitle')}</h2>
      <p className={styles.paragraph}>{t('securingContent')}</p>

      <h2 className={styles.sectionTitle}>{t('keepingTitle')}</h2>
      <p className={styles.paragraph}>{t('keepingContent1')}</p>
      <p className={styles.paragraph}>{t('keepingContent2')}</p>

      <h2 className={styles.sectionTitle}>{t('accessTitle')}</h2>
      <p className={styles.paragraph}>{t('accessList1.title')}</p>
      <ul className={styles.list}>
        <li className={styles.listItem}>{t('accessList1.item1')}</li>
        <li className={styles.listItem}>{t('accessList1.item2')}</li>
        <li className={styles.listItem}>{t('accessList1.item3')}</li>
        <li className={styles.listItem}>{t('accessList1.item4')}</li>
        <li className={styles.listItem}>{t('accessList1.item5')}</li>
        <li className={styles.listItem}>{t('accessList1.item6')}</li>
      </ul>
      <p className={styles.paragraph}>{t('accessList2.title')}</p>
      <ul className={styles.list}>
        <li className={styles.listItem}>{t('accessList2.item1')}</li>
        <li className={styles.listItem}>{t('accessList2.item2')}</li>
        <li className={styles.listItem}>{t('accessList2.item3')}</li>
        <li className={styles.listItem}>{t('accessList2.item4')}</li>
        <li className={styles.listItem}>{t('accessList2.item5')}</li>
        <li className={styles.listItem}>{t('accessList2.item6')}</li>
        <li className={styles.listItem}>{t('accessList2.item7')}</li>
      </ul>
      <p className={styles.paragraph}>{t('accessContent')}</p>

      <h2 className={styles.sectionTitle}>{t('californiaTitle')}</h2>
      <p className={styles.paragraph}>{t('californiaContent')}</p>

      <h2 className={styles.sectionTitle}>{t('requestTitle')}</h2>
      <p className={styles.paragraph}>
        {t('requestContent1.part1')}
        <a href='tel:18663333134' className={styles.link}>
          {t('requestContent1.phone')}
        </a>
        {t('requestContent1.part2')}
        <a href='mailto:dataprotection@us.domesticandgeneral.com' className={styles.link}>
          {t('requestContent1.email')}
        </a>
        {t('requestContent1.part3')}
      </p>
      <p className={styles.paragraph}>{t('requestContent2')}</p>
      <p className={styles.paragraph}>{t('requestContent2')}</p>

      <h2 className={styles.sectionTitle}>{t('marketingTitle')}</h2>
      <p className={styles.paragraph}>{t('marketingContent')}</p>

      <h2 className={styles.sectionTitle}>{t('discriminationTitle')}</h2>
      <p className={styles.paragraph}>{t('discriminationContent')}</p>

      <h2 className={styles.sectionTitle}>{t('contactTitle')}</h2>
      <p className={styles.paragraph}>
        {t('contactContent1.part1')}
        <a href='mailto:dataprotection@us.domesticandgeneral.com' className={styles.link}>
          {t('contactContent1.email')}
        </a>
        {t('contactContent1.part2')}
      </p>
      <p className={styles.paragraph}>
        {t('contactContent2.part1')}
        <br />
        {t('contactContent2.part2')}
        <br />
        {t('contactContent2.part3')}
      </p>

      <h2 className={styles.sectionTitle}>{t('cookiesTitle')}</h2>
      <p className={styles.paragraph}>{t('cookiesContent1')}</p>
      <p className={styles.paragraph}>
        {t('cookiesContent2.part1')}
        <a href='/?page=cookies' className={styles.link}>
          {t('cookiesContent2.linkText')}
        </a>
        {t('cookiesContent2.part2')}
      </p>

      <h2 className={styles.sectionTitle}>{t('doNotTrackTitle')}</h2>
      <p className={styles.paragraph}>{t('doNotTrackContent')}</p>

      <h2 className={styles.sectionTitle}>{t('thirdPartyTitle')}</h2>
      <p className={styles.paragraph}>{t('thirdPartyContent')}</p>

      <h2 className={styles.sectionTitle}>{t('customerWebsitesTitle')}</h2>
      <p className={styles.paragraph}>{t('customerWebsitesContent')}</p>

      <h2 className={styles.sectionTitle}>{t('childrenTitle')}</h2>
      <p className={styles.paragraph}>{t('childrenContent')}</p>

      <h2 className={styles.sectionTitle}>{t('accessibilityTitle')}</h2>
      <p className={styles.paragraph}>{t('accessibilityContent')}</p>

      <h2 className={styles.sectionTitle}>{t('changesTitle')}</h2>
      <p className={styles.paragraph}>{t('changesContent')}</p>
    </div>
  );
};
